enum GoogleMapTypeEnum {
  SZUKAJ,
  BIURA,
  'BIURO-SZCZEGOLY',
}
export default GoogleMapTypeEnum;
